export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14779.7d0b32e2.jpg";